function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M88.323 20.833C112.323 17.073 115.668 0 145.5 0s33.178 17.073 57.177 20.833H218a3 3 0 013 3V78H70V23.833a3 3 0 013-3h15.323z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M70.5 77.5h150V23.833a2.5 2.5 0 00-2.5-2.5l-15.4-.006c-8.848-1.386-13.929-3.787-23.808-10.126-6.273-4.025-9.225-5.697-13.555-7.366C159.525 1.635 153.222.5 145.5.5c-7.722 0-14.025 1.134-19.737 3.335-4.33 1.669-7.282 3.34-13.555 7.366-9.88 6.339-14.96 8.74-23.808 10.126l-.077.006H73a2.5 2.5 0 00-2.5 2.5V77.5z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M73.5 112H215v19.067H73.5z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M74 112.5h140.5v18.067H74z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M69 102h15l-7.968 44H69z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M69.5 102.5v43h6.115l7.786-43H69.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M221 102h-15l7.968 44H221z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M220.5 102.5v43h-6.115l-7.786-43H220.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M61 120.035V71.262C61 68.908 63.047 67 65.571 67H224.43c2.524 0 4.571 1.908 4.571 4.262v49.839c-12.992-1.428-26.913-2.142-41.762-2.142-22.275 0-50.433 3.97-73.287 4.891-15.236.614-32.887-.658-52.951-3.815z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M61.5 119.608c19.86 3.103 37.337 4.35 52.43 3.742 8.234-.331 15.036-.86 31.846-2.349l3.02-.267c18.346-1.615 28.463-2.275 38.442-2.275 14.656 0 28.41.695 41.262 2.084v-49.28c0-2.07-1.815-3.763-4.071-3.763H65.57c-2.256 0-4.071 1.693-4.071 3.762v48.346z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M99.741 48.105c6.351-.737 11.115-1.105 14.29-1.105 3.128 0 7.82.368 14.075 1.105 6.239 0 11.754 4.79 16.546 14.369C139.113 66.158 134.386 68 130.47 68H96.195C92.28 68 87.214 65.79 81 61.368c4.313-8.842 10.56-13.263 18.741-13.263z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M81.638 61.207c5.977 4.202 10.84 6.293 14.557 6.293h34.275c3.715 0 8.231-1.727 13.535-5.198-4.668-9.163-9.974-13.697-15.958-13.7-6.237-.735-10.912-1.102-14.016-1.102-3.152 0-7.899.367-14.232 1.102l-.058.003c-7.86 0-13.879 4.178-18.103 12.602z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M162.366 48.666c5.982-1.105 11.76-1.666 16.501-1.666 4.714 0 9.856.446 14.141 1.105 7.977 1.226 13.493 5.647 16.547 13.263C204.016 65.79 199.288 68 195.372 68h-34.274c-3.916 0-8.616-1.842-14.098-5.526 3.799-8.014 8.92-12.617 15.366-13.808z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M147.639 62.299c5.252 3.473 9.743 5.201 13.459 5.201h34.274c3.714 0 8.246-2.088 13.578-6.29-3.015-7.24-8.337-11.43-16.018-12.61-4.484-.69-9.58-1.1-14.065-1.1-4.793 0-10.556.576-16.41 1.658-6.168 1.14-11.104 5.502-14.818 13.14z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M10 70h39v12H10z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M10.5 70.5h38v11h-38z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M5 68h11l-5.843 78H5z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M5.5 68.5v77h4.193l5.768-77H5.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M52 68H42l4.751 78H52z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M51.5 68.5v77h-4.278l-4.69-77H51.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M0 65h57v7H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M.5 65.5h56v6H.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M34 38h5v22h-5z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M34.5 38.5h4v21h-4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M16 39h40l-9.785-24h-20.43z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M16.744 38.5l9.377-23H45.88l9.377 23H16.744z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M31 58h11a5 5 0 015 5v3H26v-3a5 5 0 015-5z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M26.5 65.5h20V63a4.5 4.5 0 00-4.5-4.5H31a4.5 4.5 0 00-4.5 4.5v2.5z"
}));

function SvgRoomSceneryBed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 229,
    height: 146,
    viewBox: "0 0 229 146",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomSceneryBed);
export default __webpack_public_path__ + "static/media/RoomSceneryBed.5467c896.svg";
export { ForwardRef as ReactComponent };